import CartPrices from './CartPrices';

export default CartPrices;
